import { atomWithStorage, createJSONStorage } from "jotai/utils";

const sessionStorage = createJSONStorage<boolean>(() =>
  typeof window === "undefined" ? (undefined as never) : window.sessionStorage
);

export const showHiddenAuctionsAtom = atomWithStorage<boolean>(
  "showHiddenAuctions",
  false,
  sessionStorage,
  { getOnInit: true }
);
